(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/widgets-campaign/assets/javascripts/frames/easter2024/easter.js') >= 0) return;  svs.modules.push('/modules/widgets-campaign/assets/javascripts/frames/easter2024/easter.js');
"use strict";

const _React = React,
  Fragment = _React.Fragment;
const easter2024Path = "".concat(svs.core.config.data.svsconfig.cdn, "/images/widgets-campaign/easter2024");
const TopFrame = () => React.createElement("div", {
  className: "easter-top-frame row pointer-none"
}, React.createElement("div", {
  className: "easter-top-frame-container relative col-md-12"
}, React.createElement("img", {
  alt: "P\xE5sk-ram-\xF6verdel",
  className: "top-frame-easter",
  src: "".concat(easter2024Path, "/top-strip.png")
})));
const BottomFrame = () => React.createElement("div", {
  className: "easter-bottom-frame row pointer-none"
}, React.createElement("div", {
  className: "easter-bottom-layers relative col-md-12"
}, React.createElement("img", {
  alt: "P\xE5sk-ram-nederdel",
  className: "bottom-frame-easter",
  src: "".concat(easter2024Path, "/bottom-strip.png")
})));
const Easter = _ref => {
  let children = _ref.children,
    _ref$showTop = _ref.showTop,
    showTop = _ref$showTop === void 0 ? true : _ref$showTop,
    _ref$showBottom = _ref.showBottom,
    showBottom = _ref$showBottom === void 0 ? true : _ref$showBottom;
  return React.createElement(Fragment, null, showTop && React.createElement(TopFrame, null), children, showBottom && React.createElement(BottomFrame, null));
};
setGlobal('svs.widgetsCampaign.frames.easter2024.Easter', Easter);

 })(window);